import React, { useCallback, useContext } from 'react'
import { tileStatus } from '@/shahrzad-assets/shared-constants/tileStatus'
import { dimens } from '@/shahrzad-assets/shared-constants/dimens'
import { fontSize, fontsWeight } from '@/shahrzad-assets/shared-constants/fonts'
import { styled } from 'styled-components'
import { useMemo } from 'react'
import type { MenuProps } from 'antd'
import { Dropdown, Skeleton, Space } from 'antd'
import { icons } from '@/shahrzad-assets/shared-asstes/icons'
import { HomeContext } from '../shared-contexts/HomeContext'
import useHandshake from '@/hooks/useHandshake'
import Image from './image/Image'

const ShahrzadServices = ({ tileData = [] }: any) => {
  const { getHandshake } = useHandshake()
  const { appTilesLoading } = useContext(HomeContext)

  const clickHandler = useCallback((tile) => {
    if (tile?.status === tileStatus.DISABLE) {
      return
    } else if (tile?.child?.length > 0) {
      return
    } else if (tile?.hasAuthentication) {
      getHandshake({ tile: tile })
    } else {
      window.location.href = tile?.url
    }
  }, [])

  const items: MenuProps['items'] = useMemo(
    () =>
      tileData?.map((tile: any) => {
        return {
          key: tile?.id,
          label: (
            <TileContainer
              status={tile?.status}
              span={6}
              onClick={(e: Event) => {
                e.stopPropagation()
                clickHandler(tile)
              }}
            >
              {appTilesLoading ? (
                <Skeleton active paragraph={{ rows: 0 }} round />
              ) : (
                <TileTitle>{tile?.title}</TileTitle>
              )}
              {tile?.child?.length > 0 && (
                <Image src={icons.ARROW_LEFT_BLACK} />
              )}
            </TileContainer>
          ),
          children:
            tile?.child?.length > 0 &&
            tile?.child?.map((subtile: any) => {
              return {
                key: subtile?.id,
                label: (
                  <TileContainer
                    span={6}
                    onClick={(e: Event) => {
                      e.stopPropagation()
                      clickHandler(subtile)
                    }}
                  >
                    {appTilesLoading ? (
                      <Skeleton active paragraph={{ rows: 0 }} round />
                    ) : (
                      <TileTitle>{subtile?.title}</TileTitle>
                    )}
                  </TileContainer>
                ),
              }
            }),
        }
      }),
    [tileData],
  )

  return (
    <>
      <CDropDown menu={{ items }}>
        <Space>
          خدمات شهرزاد
          <Image src={icons.ARROW_DOWN_BLACK} />
        </Space>
      </CDropDown>
    </>
  )
}

export default React.memo(ShahrzadServices)

const CDropDown = styled(Dropdown)``

const TileContainer = styled.div<any>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  width: ${dimens.PRINT_WIDTH};
  opacity: ${(props) => (props.status === tileStatus.DISABLE ? 0.5 : 1)};
`

const TileTitle = styled.div`
  font-size: ${fontSize.NORMAL};
  font-weight: ${fontsWeight.MEDIUM};
  padding: 0 ${dimens.SPACING_XS};
  overflow-wrap: anywhere;
`
